// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-widget-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedback-widget-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.feedback-widget-btn svg {
  width: 26px;
  height: 26px;
  stroke-width: 1.9;
}

.feedback-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1001;
}

.feedback-panel {
  position: fixed;
  top: 0;
  right: -400px;
  width: 380px;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1002;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
}

.feedback-panel.open {
  right: 0;
}

.feedback-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #4A964E;
  color: white;
}

.feedback-panel-header h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.feedback-panel-header h3 svg {
  width: 21px;
  height: 21px;
  stroke-width: 1.9;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.feedback-panel-header .close-btn {
  display: grid;
  width: 32px;
  height: 32px;
  padding: 0;
  place-items: center;
}

.feedback-panel-header .close-btn svg {
  width: 20px;
  height: 20px;
}

.feedback-panel-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

.feedback-panel-content .form-group {
  margin-bottom: 20px;
}

.feedback-panel-content label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.feedback-panel-content select,
.feedback-panel-content textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.feedback-panel-content select:focus,
.feedback-panel-content textarea:focus {
  outline: none;
  border-color: #4A964E;
}

.feedback-panel-content textarea {
  resize: vertical;
  min-height: 120px;
}

.error-text {
  color: #dc3545;
  font-size: 13px;
  margin-bottom: 16px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: #4A964E;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.submit-btn:hover:not(:disabled) {
  background: #3d7a40;
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.success-message {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  color: #4A964E;
  margin-bottom: 16px;
}

.success-icon svg {
  width: 52px;
  height: 52px;
  stroke-width: 1.7;
}

.success-message h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 20px;
}

.success-message p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

@media (max-width: 480px) {
  .feedback-panel {
    width: 100%;
    right: -100%;
  }

  .feedback-widget-btn {
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/FeedbackWidget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".feedback-widget-btn {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.feedback-widget-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\n}\n\n.feedback-widget-btn svg {\n  width: 26px;\n  height: 26px;\n  stroke-width: 1.9;\n}\n\n.feedback-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1001;\n}\n\n.feedback-panel {\n  position: fixed;\n  top: 0;\n  right: -400px;\n  width: 380px;\n  height: 100vh;\n  background: white;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1002;\n  transition: right 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.feedback-panel.open {\n  right: 0;\n}\n\n.feedback-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: #4A964E;\n  color: white;\n}\n\n.feedback-panel-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.feedback-panel-header h3 svg {\n  width: 21px;\n  height: 21px;\n  stroke-width: 1.9;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.feedback-panel-header .close-btn {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  place-items: center;\n}\n\n.feedback-panel-header .close-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.feedback-panel-content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.feedback-panel-content .form-group {\n  margin-bottom: 20px;\n}\n\n.feedback-panel-content label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.feedback-panel-content select,\n.feedback-panel-content textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.feedback-panel-content select:focus,\n.feedback-panel-content textarea:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n.feedback-panel-content textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 14px;\n  background: #4A964E;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #3d7a40;\n}\n\n.submit-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.success-message {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.success-icon {\n  color: #4A964E;\n  margin-bottom: 16px;\n}\n\n.success-icon svg {\n  width: 52px;\n  height: 52px;\n  stroke-width: 1.7;\n}\n\n.success-message h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.success-message p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n@media (max-width: 480px) {\n  .feedback-panel {\n    width: 100%;\n    right: -100%;\n  }\n\n  .feedback-widget-btn {\n    bottom: 16px;\n    right: 16px;\n    width: 48px;\n    height: 48px;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
